import { ProgressBarPalette } from 'components/progressBars/helpers';
import { useTheme } from './theme';

export const useProgressBarPallete = () => {
  const {
    cloudGradient,
    greenGradient,
    purpleGradient,
    pinkGradient,
    orangeGradient,
    yellowGradient,
    platinumGradient,
    grayColor4,
    grayColor5,
    emeraldGradient,
  } = useTheme();

  return {
    [ProgressBarPalette.CLOUD]: cloudGradient,
    [ProgressBarPalette.GREEN]: greenGradient,
    [ProgressBarPalette.PURPLE]: purpleGradient,
    [ProgressBarPalette.PINK]: pinkGradient,
    [ProgressBarPalette.ORANGE]: orangeGradient,
    [ProgressBarPalette.YELLOW]: yellowGradient,
    [ProgressBarPalette.PLATINUM]: platinumGradient,
    [ProgressBarPalette.GRAY]: grayColor5,
    [ProgressBarPalette.DARK_GRAY]: grayColor4,
    [ProgressBarPalette.EMERALD]: emeraldGradient,
  };
};
